export const unlinkCode = {
    "curl": {
      "request": `curl -X 'POST' 
'https://demo-api.westpay.se/in-store/api/v1/terminal/unlink'
-H 'accept: text/plain'
-H 'Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImRlZWxha2EiLCJyb2xlIjoiTWVyY2hhbnQiLCJuYmYiOjE2ODMwMzU5MTUsImV4cCI6MTY4ODIxOTkxNSwiaWF0IjoxNjgzMDM1OTE1LCJpc3MiOiJXZXN0cGF5IEFCIiwiYXVkIjoiZGVlbGFrYVBvc3RtYW4xIn0.lfqUjrGF_1SH1iBV_Fs57K0y4fjWQapZy349PN2_sco'
-H 'Ocp-Apim-Subscription-Key: 76591d32138f4f60b580db9ec9167f1d'
-H 'Content-Type: application/json'
-d '{
    "terminalId": "80000456"
}'`
    },
    "java": {
      "request": `import java.io.BufferedReader;
import java.io.InputStreamReader;
import java.io.OutputStream;
import java.net.HttpURLConnection;
import java.net.URL;
      
import com.google.gson.Gson;
      
public class TerminalUnlinkingExample {
    public static void main(String[] args) {
        try {
            // Set the cURL command parameters
            String url = "https://demo-api.westpay.se/in-store/api/v1/terminal/unlink";
            String acceptHeader = "text/plain";
            String ocpApimSubscriptionKey = "76591d32138f4f60b580db9ec9167f1d";
            String authorizationHeader = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImRlZWxha2EiLCJyb2xlIjoiTWVyY2hhbn";
            String contentTypeHeader = "application/json";
                  
            // Create a TerminalUnlinkingRequest object
            TerminalUnlinkingRequest request = new TerminalUnlinkingRequest();
            request.setTerminalId("80000456");
      
            // Convert the object to JSON string
            Gson gson = new Gson();
            String requestBody = gson.toJson(request);
      
            // Create a URL object with the endpoint
            URL apiUrl = new URL(url);
      
            // Open a connection to the URL
            HttpURLConnection connection = (HttpURLConnection) apiUrl.openConnection();
            connection.setRequestMethod("POST");
            connection.setRequestProperty("Accept", acceptHeader);
            connection.setRequestProperty("Ocp-Apim-Subscription-Key", ocpApimSubscriptionKey);
            connection.setRequestProperty("Authorization", authorizationHeader);
            connection.setRequestProperty("Content-Type", contentTypeHeader);
            connection.setDoOutput(true);
      
            // Write the request body to the connection's output stream
            OutputStream outputStream = connection.getOutputStream();
            outputStream.write(requestBody.getBytes());
            outputStream.flush();
            outputStream.close();
      
            // Get the response from the API
            int responseCode = connection.getResponseCode();
      
            // Read the response
            BufferedReader reader;
            if (responseCode >= 200 && responseCode < 300) {
                reader = new BufferedReader(new InputStreamReader(connection.getInputStream()));
            } else {
                reader = new BufferedReader(new InputStreamReader(connection.getErrorStream()));
            }
      
            // Process the response
            String line;
            StringBuilder response = new StringBuilder();
            while ((line = reader.readLine()) != null) {
                response.append(line);
            }
            reader.close();
      
            // Print the response
            System.out.println("Response Code: " + responseCode);
            System.out.println("Response Body: " + response.toString());
        } catch (Exception e) {
            // Handle any exceptions that occur
            e.printStackTrace();
        }
    }
}
      
// TerminalUnlinkingRequest class
class TerminalUnlinkingRequest {
    private String terminalId;
      
    public String getTerminalId() {
        return terminalId;
    }
      
    public void setTerminalId(String terminalId) {
        this.terminalId = terminalId;
    }
}`
    },
    "C#": {
      "request": `using System;
using System.IO;
using System.Net;
using System.Text;
using Newtonsoft.Json;
      
namespace TerminalUnlinkingExample
{
    class TerminalUnlinkingRequest
    {
        public string TerminalId { get; set; }
    }
      
    class Program
    {
        static void Main(string[] args)
        {
            try
          {
                // Set the cURL command parameters
                string url = "https://demo-api.westpay.se/in-store/api/v1/terminal/unlink";
                string acceptHeader = "text/plain";
                string ocpApimSubscriptionKey = "76591d32138f4f60b580db9ec9167f1d";
                string authorizationHeader = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImRlZWxha2EiLCJyb2xlIjoiTWVyY2hhbn";
                string contentTypeHeader = "application/json";
      
                // Create a TerminalUnlinkingRequest object
                TerminalUnlinkingRequest request = new TerminalUnlinkingRequest { TerminalId = "80000456" };
      
                // Serialize the request object to JSON
                string requestBody = JsonConvert.SerializeObject(request);
      
                // Create a WebRequest with the endpoint URL
                WebRequest webRequest = WebRequest.Create(url);
                webRequest.Method = "POST";
                webRequest.Headers.Add("Accept", acceptHeader);
                webRequest.Headers.Add("Ocp-Apim-Subscription-Key", ocpApimSubscriptionKey);
                webRequest.Headers.Add("Authorization", authorizationHeader);
                webRequest.ContentType = contentTypeHeader;
      
                // Write the request body to the WebRequest's stream
                using (StreamWriter writer = new StreamWriter(webRequest.GetRequestStream()))
                {
                    writer.Write(requestBody);
                }
      
                // Get the response from the API
                WebResponse webResponse = webRequest.GetResponse();
                HttpStatusCode responseCode = ((HttpWebResponse)webResponse).StatusCode;
      
                // Read the response
                using (StreamReader reader = new StreamReader(webResponse.GetResponseStream(), Encoding.UTF8))
                {
                    string responseBody = reader.ReadToEnd();
                    // Print the response
                    Console.WriteLine("Response Code: " + (int)responseCode);
                    Console.WriteLine("Response Body: " + responseBody);
                }
      
                webResponse.Close();
            }
            catch (Exception ex)
            {
                // Handle any exceptions that occur
                Console.WriteLine("Exception: " + ex.Message);
            }
        }
    }
}`
    },
    "python": {
      "request": `import requests
import json
      
class TerminalUnlinkingRequest:
    def __init__(self, terminalId):
        self.terminalId = terminalId
      
# Set the cURL command parameters
url = "https://demo-api.westpay.se/in-store/api/v1/terminal/unlink"
acceptHeader = "text/plain"
authorizationHeader = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImRlZWxha2EiLCJyb2xlIjoiTWVyY2hhbn"
ocpApimSubscriptionKey = "76591d32138f4f60b580db9ec9167f1d"
contentTypeHeader = "application/json"
      
# Create a TerminalUnlinkingRequest object
request = TerminalUnlinkingRequest(terminalId="80000456")
      
# Convert the object to JSON string
requestBody = json.dumps(request.__dict__)
      
# Set the headers
headers = {
    "Accept": acceptHeader,
    "Authorization": authorizationHeader,
    "Ocp-Apim-Subscription-Key": ocpApimSubscriptionKey,
    "Content-Type": contentTypeHeader
}
      
try:
    # Send the POST request
    response = requests.post(url, data=requestBody, headers=headers)
      
    # Get the response code and body
    responseCode = response.status_code
    responseBody = response.text
      
    # Print the response
    print("Response Code:", responseCode)
    print("Response Body:", responseBody)
      
except Exception as e:
    # Handle any exceptions that occur
    print("Exception:", str(e))`
    },
    
    "JavaScript": {
      "request": `class TerminalUnlinkingRequest {
  constructor(terminalId) {
    this.terminalId = terminalId;
  }
}
      
// Set the cURL command parameters
const url = "https://demo-api.westpay.se/in-store/api/v1/terminal/unlink";
const acceptHeader = "text/plain";
const authorizationHeader = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImRlZWxha2EiLCJyb2xlIjoiTWVyY2hhbn";
const ocpApimSubscriptionKey = "76591d32138f4f60b580db9ec9167f1d";
const contentTypeHeader = "application/json";
      
// Create a TerminalUnlinkingRequest object
const request = new TerminalUnlinkingRequest("80000456");
      
// Convert the object to JSON string
const requestBody = JSON.stringify(request);
      
// Set the headers
const headers = new Headers();
headers.append("Accept", acceptHeader);
headers.append("Authorization", authorizationHeader);
headers.append("Ocp-Apim-Subscription-Key", ocpApimSubscriptionKey);
headers.append("Content-Type", contentTypeHeader);
      
// Set the request options
const requestOptions = {
  method: "POST",
  headers: headers,
  body: requestBody
};
      
try {
  // Send the POST request
  fetch(url, requestOptions)
    .then(response => {
      // Get the response code
      const responseCode = response.status;
      
      // Parse the response body as text or JSON
      response.text().then(responseBody => {
        // Print the response
        console.log("Response Code:", responseCode);
        console.log("Response Body:", responseBody);
      });
    })
    .catch(error => {
      // Handle any errors that occur during the request
      console.error("Error:", error);
    });
} catch (error) {
  // Handle any exceptions that occur
  console.error("Exception:", error);
}`
    }
  };

  export const unlinkCodeResponse = `200 OK Response without response body`;
  